import React from 'react';
import { Phone } from 'lucide-react';
export function WaterlessFeature() {
  return <section className="bg-[#1A1A1A] overflow-hidden" data-id="element-263">
      <div className="flex flex-col lg:flex-row" data-id="element-264">
        {/* Content Side */}
        <div className="w-full lg:w-1/2 py-20 px-4 md:px-12 lg:px-20 flex flex-col justify-center" data-id="element-265">
          <span className="text-[#7FD4D4] font-bold tracking-[0.2em] text-sm uppercase block mb-4" data-id="element-266">
            Our Process
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase mb-6 leading-tight" data-id="element-267">
            Spotless, No-Mess Shine with Waterless Detailing
          </h2>
          <p className="text-white/70 text-lg leading-relaxed mb-8 font-inter" data-id="element-268">
            Our innovative waterless process uses advanced polymer technology to
            lift dirt and grime away from your paint, encapsulating it for a
            scratch-free removal.
            <br data-id="element-269" />
            <br data-id="element-270" />
            No hoses, no water runoff, and no mess on your driveway. It's the
            perfect solution for urban environments, apartment complexes, and
            HOA-restricted neighborhoods. Plus, it leaves a protective finish
            that keeps your car cleaner, longer.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-271">
            <a href="#booking" className="bg-[#7FD4D4] text-black px-8 py-4 font-bold text-center uppercase tracking-wide rounded-sm hover:bg-[#6BC4C4] transition-colors" data-id="element-272">
              Book Online
            </a>
            <a href="tel:602-641-5089" className="border border-white text-white px-8 py-4 font-bold text-center uppercase tracking-wide rounded-sm hover:bg-white hover:text-black transition-colors flex items-center justify-center" data-id="element-273">
              <Phone size={18} className="mr-2" data-id="element-274" />
              Call 602-641-5089
            </a>
          </div>
        </div>

        {/* Image Side */}
        <div className="w-full lg:w-1/2 h-[500px] lg:h-auto relative" data-id="element-275">
          <div className="absolute inset-0 bg-black/20 z-10" data-id="element-276"></div>
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/f7977235-f749-4aa8-a104-32463b5fc6c1/capstone-detailing.jpg" alt="Detailer working on a car" className="w-full h-full object-cover" data-id="element-277" />
        </div>
      </div>
    </section>;
}